export function isValid (v) {
  return v !== '' && v !== null && v !== undefined
}



// WEBPACK FOOTER //
// ./src/utils/validation.js